import Highcharts from "highcharts";

document.addEventListener("turbo:load", () => {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='recon_rating_bar']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const categories: Array<{ grade: string; range: string }> = JSON.parse(
        chart.dataset.categories!,
      );
      const seriesData: Array<{
        x: number;
        y: number;
        color: string;
      }> = JSON.parse(chart.dataset.seriesData!);

      Highcharts.chart({
        chart: {
          renderTo: chart,
          type: "column",
        },
        legend: {
          enabled: false,
        },
        title: { text: undefined },
        xAxis: {
          // Categories are objects ({ grade, range }) rather than plain strings;
          // the label formatter reads those fields off the category value at runtime.
          categories: categories as unknown as string[],
          labels: {
            style: {
              fontSize: "14px",
            },
            y: 25,
            formatter: function () {
              const value = this.value as unknown as {
                grade: string;
                range: string;
              };
              const row1 = "<strong>" + value.grade + "<br>";
              const row2 = value.range;
              return row1 + row2;
            },
          },
        },
        yAxis: {
          allowDecimals: false,
          min: 0,
          title: { text: undefined },
          labels: {
            style: {
              fontSize: "14px",
              fontWeight: "bold",
            },
          },
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              style: {
                fontSize: "14",
                fontWeight: "normal",
              },
            },
          },
          column: {
            pointPadding: 0.2,
            groupPadding: 0.1,
            borderWidth: 0,
          },
        },
        series: [
          {
            data: seriesData,
          },
        ],
      });
    });
  }
});
